module.exports = __webpack_public_path__ + "img/img_file_thumb03.0e65aee9.png";